import { 
    GET_ALL_JOBS,
    CREATE_JOB,
    DELETE_JOB,
    GET_JOB_FUNCTION,
    POST_JOB_FUNCTION,
    SAVE_ALL_JOBS,
    SAVE_JOB_FUNCTION,
    DELETE_JOB_FUNCTION,
    RESET_SCHEDULE
} from "../constants/Schedule";

export const getAllJobs = () => {
    return {
        type: GET_ALL_JOBS
    }
};

export const createJob = (data) => {
    return {
        type: CREATE_JOB,
        payload: data
    }
};

export const resetSchedule = () => {
    return {
        type: RESET_SCHEDULE,
        
    }
};

export const deleteJob = (name) => {
    return {
        type: DELETE_JOB,
        payload: {name}
    }
}

export const getJobFunction = (name) => {
    return {
        type: GET_JOB_FUNCTION,
        payload: {name}
    }
}

export const postJobFunction = ({name, code, data}) => {
    return {
        type: POST_JOB_FUNCTION,
        payload: {name, code, data}
    }
}

export const deleteJobFunction = (name) => {
    return {
        type: DELETE_JOB_FUNCTION,
        payload: {name}
    }
}

export const saveAllJobs = (items) => {
    return {
        type: SAVE_ALL_JOBS,
        payload: items
    }
}

export const saveJobFunction = (data) => {
    return {
        type: SAVE_JOB_FUNCTION,
        payload: data
    }
}